import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import withRouter from 'react-router-dom/withRouter';
import { hasCompletedOnboarding } from 'utils/helpers';
import { push } from 'react-router-redux/actions';
import Spinner from 'components/Spinner/Spinner';
import { checkAuthStatus } from 'api/auth';
import { getAuthedUserProfile } from 'api/users';
import { isAuthed, setLoginStepTwo, toggleShouldReload } from 'redux/modules/authentication';
import { publicPaths } from 'config/constants';
import { deleteLoginToken, setApiRequestToken } from 'utils/helpers';


class AppLoadingContainer extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        children: PropTypes.element.isRequired,
        location: PropTypes.object.isRequired,
        shouldReload: PropTypes.bool.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        isCoach: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired
    }

    state = {
        appIsReady: false
    }

    async componentDidMount() {
        this.prepareApp();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.shouldReload && this.props.shouldReload) {
            this.reloadApp();
        }
    }

    prepareApp = async () => {
        try {

            setApiRequestToken();
            const { data } = await checkAuthStatus();

            if (JSON.parse(data.result) === true) {
                const userResp = await getAuthedUserProfile();

                await this.props.dispatch(isAuthed(userResp.data));
                await this.props.dispatch(setLoginStepTwo({
                    current_role: userResp.data.current_role,
                    current_group: userResp.data.current_group
                }));

                this.flag = hasCompletedOnboarding(userResp.data);

                if (!this.flag && userResp.data.role_type !== 2 && publicPaths.indexOf(this.props.location.pathname) === -1) {
                    this.props.dispatch(push('/onboard'));

                    return false;
                }
            }
            else {
                deleteLoginToken();
            }
        }
        finally {
            this.setState({
                appIsReady: true,
            });
        }
    }

    reloadApp = () => {
        this.setState({
            appIsReady: false
        }, () => {
            this.props.history.replace('/');

            if (this.props.isAdmin) {
                this.props.history.push('group/list');
            }
            else if (this.props.isCoach) {
                this.props.history.push('assignments/feedbacks');
            }
            else {
                this.props.history.push('pla/initial');
            }
        });

        setTimeout(() => {
            this.props.dispatch(toggleShouldReload(false));

            this.setState({
                appIsReady: true
            });
        }, 300);
    }

    render() {
        if (this.state.appIsReady) {
            return this.props.children;
        }

        return (
            <div className='main-screen'>
                <div className='loading-container text-center'>
                    <Spinner color='#790000' />
                </div>
            </div>
        );
    }
}

function mapStateToProps({ authentication }) {
    return {
        shouldReload: authentication.shouldReload,
        isAdmin: authentication.isAdmin,
        isCoach: authentication.isCoach
    };
}

export default withRouter(connect(mapStateToProps)(AppLoadingContainer));



// WEBPACK FOOTER //
// ./src/containers/AppLoading/AppLoadingContainer.js